export const WALLET_TABS = [
  { key: 'resumo', labelKey: 'my_wallet.tabs.summary' },
  { key: 'modelo-de-recebimento', labelKey: 'my_wallet.tabs.receiving_model' },
] as const

export type WalletTabKey = typeof WALLET_TABS[number]['key']

export const DEFAULT_WALLET_TAB: WalletTabKey = 'resumo'
export const RECEIVING_MODEL_TAB: WalletTabKey = 'modelo-de-recebimento'

export function isWalletTab(value: unknown): value is WalletTabKey {
  return WALLET_TABS.some(tab => tab.key === value)
}

export function resolveLegacyContext(context: unknown): WalletTabKey {
  return isWalletTab(context) ? context : DEFAULT_WALLET_TAB
}
